import i18n from 'i18next'
import authStore from 'store/auth/auth'

//descriptions from https://app-eu.wrike.com/open.htm?id=1625431432
const commonSettingsHelpTextUntranslatedKeys: { [key: string]: string } = {
  'availability.help_text': 'Binary setting that indicates if the unit is available or not', //Tillgänglighet
  'forced.help_text': 'Binary setting that forces production of the unit according to specified settings', //Tvångskörning
  'forced_activity.help_text':
    'The unit must operate at the specified power in MW (when the setting applies, limiting conditions in the model are ignored)', //Tvingad effekt
  'forced_min.help_text': 'Forces production of the unit at minimum of the set output (MW)', //Tvingad min-effekt
  'load_change_rate.help_text': 'Setting that indicates how much a unit can alter its output per hour (MW/h)', //Laständringshastighet
  'max_thermal_effect.help_text': 'Maximum allowed output during operation (MW)', //Max. termisk effekt
  'min_thermal_effect.help_text': 'Minimum allowed output during operation (MW)', //Min. termisk effekt,
  'max_level.help_text': 'Maximum accumulator level (MWh)', //Max. nivå
  'min_level.help_text': 'Minimum accumulator level (MWh)', //Min. nivå,
  'max_inflow.help_text': 'Maximum allowed charging of accumulator (MW)', //Max. flöde in
  'max_outflow.help_text': 'Maximum allowed discharging of accumulator (MW)', //Max. flöde ut
  'min_inflow.help_text': 'Minimum allowed charging of accumulator (MW)', //Min. flöde in
  'min_outflow.help_text': 'Minimum allowed discharging of accumulator (MW)', //Min. flöde ut
  'max_thermal.help_text': 'Maximum allowed output during operation (MW)', //Max. termisk effekt
  'min_thermal.help_text': 'Minimum allowed output during operation (MW)', //Min. termisk effekt
  'max_heat.help_text': 'Maximum allowed output during operation (MW)', //Max. värme
  'min_heat.help_text': 'Minimum allowed output during operation (MW)', //Min. värme
  'min_output.help_text': 'Minimum allowed output during operation (MW)', //Min. uteffekt
  'max_output.help_text': 'Maximum allowed output during operation (MW)', //Max. uteffekt,
  'min_downtime.help_text':
    'Least amount of hours a unit needs to be shut off after a stop, before it can be started again (h)', //Min. nedtid
  'min_uptime.help_text':
    'Least amount of hours a unit needs to be online after a start, before it can be shut off (h)', //Min. upptid
}

export function keyToSourceFromUntranslatedHelpTexts(key: string): string {
  if (commonSettingsHelpTextUntranslatedKeys[key]) {
    return commonSettingsHelpTextUntranslatedKeys[key]
  }
  return key
}

export function keyToSourceFromTranslatedHelpTexts(key: string): string {
  //function to fetch corresponding translated string from key, need to be evaluated in the context of the component in the function as the translations uses parametres (as apposed to the untranslated one above)
  const commonSettingsHelpTextTranslatedKeys: { [key: string]: string } = {
    'load_change_cost.help_text': i18n.t('Fictive cost applied for changed output ({{currency}}/MW)', {
      currency: authStore.activeSystem?.currency,
    }), //Laständringskostnad
    'start_cost.help_text': i18n.t('Fictive cost applied if the unit has started ({{currency}})', {
      currency: authStore.activeSystem?.currency,
    }), //Startkostnad
    'run_cost.help_text': i18n.t('Cost per produced output ({{currency}}/MWh)', {
      currency: authStore.activeSystem?.currency,
    }), //use translation function here because it has parametres
  }
  if (commonSettingsHelpTextTranslatedKeys[key]) {
    return commonSettingsHelpTextTranslatedKeys[key]
  }

  return key
}
